<div class="py-2.5 px-7">
  <app-section-header
    [title]="'Admin - Edit Author'"
    [isBackBtnShown]="isAdmin$ | async"
    [preserveQueryParam]="true"
  >
    <div class="flex justify-end flex-1">
      <button
        mat-flat-button
        color="primary"
        class="w-1/4 ml-3"
        (click)="updateAuthor()"
        [disabled]="isSaveDisabled()"
      >
        <span *ngIf="!isUpdating">Save</span>
        <span *ngIf="isUpdating">Saving</span>
      </button>
    </div>
  </app-section-header>

  <div class="pt-2.5 border-b border-project-200">
    <label class="px-4 pt-6 text-base font-normal font-montserrat">Name:</label>
    <div class="flex flex-wrap">
      <mat-form-field
        appearance="outline"
        [floatLabel]="'never'"
        class="w-1/4 author_search-box edit_author-box"
        title="Please fill out this field"
      >
        <input type="text" matInput [formControl]="authorNameInput" />
      </mat-form-field>
    </div>
  </div>

  <div class="pt-2.5 border-b border-project-200">
    <label class="px-4 pt-6 text-base font-normal font-montserrat"
      >Location:</label
    >
    <div class="flex flex-wrap">
      <mat-form-field
        appearance="outline"
        [floatLabel]="'never'"
        class="w-1/4 author_search-box edit_author-box"
        title="Please fill out this field"
      >
        <input type="text" matInput [formControl]="authorLocationInput" />
      </mat-form-field>
    </div>
  </div>
</div>
